import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import './WhatWeEnable.css';

const WhatWeEnable = () => {
  const { t } = useTranslation();
  const sectionRef = useRef(null);
  const titleRef = useRef(null);
  const descriptionRef = useRef(null);
  const featuresRef = useRef(null);
  
  // Animation on scroll
  useEffect(() => {
    const section = sectionRef.current;
    const title = titleRef.current;
    const description = descriptionRef.current;
    const features = featuresRef.current;
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          section.classList.add('visible');
          setTimeout(() => title.classList.add('visible'), 50);
          setTimeout(() => description.classList.add('visible'), 100);
          setTimeout(() => features.classList.add('visible'), 150);
          
          // Animate feature items with staggered delay (much faster)
          const featureItems = features.querySelectorAll('.feature-item');
          featureItems.forEach((item, index) => {
            setTimeout(() => item.classList.add('visible'), 150 + (index * 50));
          });
          
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });
    
    if (section) {
      observer.observe(section);
    }
    
    return () => {
      if (section) {
        observer.unobserve(section);
      }
    };
  }, []);

  return (
    <section className="what-we-enable" ref={sectionRef}>
      <div className="what-we-enable-background">
        <div className="what-we-enable-shape what-we-enable-shape-1"></div>
        <div className="what-we-enable-shape what-we-enable-shape-2"></div>
      </div>
      
      <div className="container">
        <div className="what-we-enable-content">
          <h2 className="what-we-enable-title" ref={titleRef}>
            {t('whatWeEnableTitle')}
          </h2>
          
          <p className="what-we-enable-description" ref={descriptionRef}>
            {t('whatWeEnableDescription')}
          </p>
          
          <div className="what-we-enable-features" ref={featuresRef}>
            <div className="feature-item">
              <div className="feature-number">01</div>
              <div className="feature-content">
                <h3 className="feature-title">{t('whatWeEnableItem1').split(':')[0]}</h3>
                <p className="feature-description">{t('whatWeEnableItem1').split(':')[1]}</p>
              </div>
            </div>
            
            <div className="feature-item">
              <div className="feature-number">02</div>
              <div className="feature-content">
                <h3 className="feature-title">{t('whatWeEnableItem2').split(':')[0]}</h3>
                <p className="feature-description">{t('whatWeEnableItem2').split(':')[1]}</p>
              </div>
            </div>
            
            <div className="feature-item">
              <div className="feature-number">03</div>
              <div className="feature-content">
                <h3 className="feature-title">{t('whatWeEnableItem3').split(':')[0]}</h3>
                <p className="feature-description">{t('whatWeEnableItem3').split(':')[1]}</p>
              </div>
            </div>
            
            <div className="feature-item">
              <div className="feature-number">04</div>
              <div className="feature-content">
                <h3 className="feature-title">{t('whatWeEnableItem4').split(':')[0]}</h3>
                <p className="feature-description">{t('whatWeEnableItem4').split(':')[1]}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatWeEnable;
